import URLSearchParams from 'url-search-params';

// import {stringify,parse} from 'querystring';

// window.stringify = stringify;
// window.parse = parse;

//window.URLSearchParams = URLSearchParams;

const currentParams = new URLSearchParams(location.search);

//获取当前URL的所有参数
export function getSearchParams() {
  let result = {};
  for (let item of currentParams) {
    let [key,value] = item;
    if(value===null||value===undefined) continue;
    try{
      value = JSON.parse(value);
    }catch(e){}
    result[key] = value;
  }
  return result;
}

//设置当前URL的参数
export function setSearchParams(params) {
  for (let key in params) {
    if (!params.hasOwnProperty(key)) continue;
    let value = params[key];
    if(value&&typeof value=='object') value = JSON.stringify(value);
    if(value===null||value===undefined){
      currentParams.delete(key);
    }else{
      currentParams.set(key, value);
    }
  }
  window.history.replaceState({}, '', `${location.pathname}?${currentParams}`);
}



// WEBPACK FOOTER //
// ./src/helper/url.js